module.exports = __webpack_public_path__ + "static/media/right1.28489108.png";